<template>
  <div class="redeem-code">
    <MainLayout>
      <template v-slot>
        <div @click="$router.push('/help')" class="help">
          <svg
            width="76"
            height="76"
            viewBox="0 0 76 76"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g filter="url(#filter0_d_801_430)">
              <circle cx="38" cy="38" r="28" fill="#337AB7" />
            </g>
            <path
              d="M36.3452 43.4545V43.3182C36.3603 41.8712 36.5118 40.7197 36.7997 39.8636C37.0876 39.0076 37.4967 38.3144 38.027 37.7841C38.5573 37.2538 39.1937 36.7652 39.9361 36.3182C40.383 36.0455 40.7846 35.7235 41.1406 35.3523C41.4967 34.9735 41.777 34.5379 41.9815 34.0455C42.1937 33.553 42.2997 33.0076 42.2997 32.4091C42.2997 31.6667 42.1255 31.0227 41.777 30.4773C41.4285 29.9318 40.9626 29.5114 40.3793 29.2159C39.7959 28.9205 39.1482 28.7727 38.4361 28.7727C37.8149 28.7727 37.2164 28.9015 36.6406 29.1591C36.0649 29.4167 35.5838 29.822 35.1974 30.375C34.8111 30.928 34.5876 31.6515 34.527 32.5455H31.6634C31.724 31.2576 32.0573 30.1553 32.6634 29.2386C33.277 28.322 34.0838 27.6212 35.0838 27.1364C36.0914 26.6515 37.2088 26.4091 38.4361 26.4091C39.7694 26.4091 40.9285 26.6742 41.9134 27.2045C42.9058 27.7348 43.6709 28.4621 44.2088 29.3864C44.7543 30.3106 45.027 31.3636 45.027 32.5455C45.027 33.3788 44.8982 34.1326 44.6406 34.8068C44.3906 35.4811 44.027 36.0833 43.5497 36.6136C43.08 37.1439 42.5118 37.6136 41.8452 38.0227C41.1785 38.4394 40.6444 38.8788 40.2429 39.3409C39.8414 39.7955 39.5497 40.3371 39.3679 40.9659C39.1861 41.5947 39.0876 42.3788 39.0724 43.3182V43.4545H36.3452ZM37.7997 50.1818C37.2391 50.1818 36.758 49.9811 36.3565 49.5795C35.955 49.178 35.7543 48.697 35.7543 48.1364C35.7543 47.5758 35.955 47.0947 36.3565 46.6932C36.758 46.2917 37.2391 46.0909 37.7997 46.0909C38.3603 46.0909 38.8414 46.2917 39.2429 46.6932C39.6444 47.0947 39.8452 47.5758 39.8452 48.1364C39.8452 48.5076 39.7505 48.8485 39.5611 49.1591C39.3793 49.4697 39.133 49.7197 38.8224 49.9091C38.5194 50.0909 38.1785 50.1818 37.7997 50.1818Z"
              fill="white"
            />
            <defs>
              <filter
                id="filter0_d_801_430"
                x="0"
                y="0"
                width="76"
                height="76"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
              >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset />
                <feGaussianBlur stdDeviation="5" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                />
                <feBlend
                  mode="normal"
                  in2="BackgroundImageFix"
                  result="effect1_dropShadow_801_430"
                />
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="effect1_dropShadow_801_430"
                  result="shape"
                />
              </filter>
            </defs>
          </svg>
        </div>
        <div style="color: red; text-align: center" class="" v-if="isError">
          {{ error }}
        </div>
        <div v-if="!isLoading && !isError" class="container">
          <div class="container__back-btn">
            <img @click="$router.back()" src="../assets/backArrow.svg" />
          </div>
          <div class="container__title">
            Wprowadź
            <span style="font-weight: 700">KOD PLACÓWKI</span> otrzymany w
            sekretariacie
          </div>
          <div class="container__code">
            <venCodeInput
              v-model="vvalue"
              :length="6"
              :numbersOnly="true"
              :inFocus="true"
              @changed="changed"
            />
          </div>
          <div
            v-if="(submitted && vvalue.length !== 6) || fieldError"
            class="container__error"
          >
            NIEPOPRAWNY <span style="font-weight: 700">KOD PLACÓWKI</span>
          </div>
          <PlaceDetails
            v-if="foundPlace && foundPlace.panel"
            :panel="foundPlace.panel"
            :enabled="foundPlace ? true : false"
          />
          <!-- <AppButton
            @click="submit"
            style="max-width: 400px; margin: auto; margin-top: 50px"
            :text="'Dodaj placówkę'"
            :plus="true"
          /> -->
        </div>
        <div v-if="isLoading" style="text-align: center; margin-top: 10px">
          Ładowanie...
        </div>
      </template>
    </MainLayout>
  </div>
</template>

<script lang="ts" setup>
import MainLayout from "@/layouts/MainLayout.vue";
import venCodeInput from "@venegrad/vue3-code-input";
import { onMounted, ref } from "vue";
import AppButton from "@/components/AppButton.vue";
import PlaceDetails from "@/components/PlaceDetails.vue";
import { useGetCodesQuery, Code } from "../api/places";

const vvalue = ref();
const fieldError = ref(false);
const submitted = ref(false);
const foundPlace = ref();

const { data, isLoading, error, isError } = useGetCodesQuery();

const changed = (v: string) => {
  if (v.length < 6) {
    foundPlace.value = undefined;
    return;
  }
  submit();
};

const submit = () => {
  submitted.value = true;
  const existingCodes = data.value?.map((el: Code) => el.kod);
  if (!existingCodes?.includes(parseInt(vvalue.value))) {
    fieldError.value = true;
    foundPlace.value = undefined;

    return;
  }
  const found = data.value?.find((el) => el.kod === parseInt(vvalue.value));
  foundPlace.value = found;
  fieldError.value = false;
};
</script>

<style scoped lang="scss">
.help {
  position: fixed;
  bottom: 10px;
  left: 10px;
  cursor: pointer;
}
.container {
  display: flex;
  flex-direction: column;
  &__code {
    padding: 0 10px;
  }
  &__title {
    font-size: 16px;
    font-weight: 400;
    padding: 20px;
    text-align: center;
    max-width: 210px;
    margin: auto;
    margin-bottom: 15px;
  }
  &__error {
    color: #ff0000;
    text-align: center;
    margin-top: 20px;
  }
  &__back-btn {
    position: absolute;
    cursor: pointer;
    top: 0;
  }
}
</style>
